import React from "react";
import { motion } from "framer-motion";

/**
 * PageHero — banner with background image, gradient, kicker + title + optional subtitle.
 * Use on top of internal dashboard pages for visual richness.
 */
export default function PageHero({ kicker, title, subtitle, image, testId, accent = "primary", right = null }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-3xl mb-8 border border-border/70"
      data-testid={testId}
    >
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/85 to-background/40" />
      </div>
      <div className="relative z-10 px-6 py-8 lg:px-10 lg:py-12 flex flex-col lg:flex-row lg:items-end justify-between gap-6">
        <div className="max-w-xl">
          {kicker && <div className={`text-xs uppercase tracking-[0.25em] mb-2 font-semibold text-[hsl(var(--${accent}))]`}>{kicker}</div>}
          <h1 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-2 text-sm lg:text-base">{subtitle}</p>}
        </div>
        {right && <div>{right}</div>}
      </div>
    </motion.div>
  );
}
